import React from 'react';
import { motion } from 'framer-motion';
export function ExampleBlock() {
  return <section className="bg-[#17304F] py-16 px-6" data-id="element-57">
      <div className="max-w-2xl mx-auto" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-59">
          <h3 className="text-xl md:text-2xl font-bold text-white mb-8 text-center" data-id="element-60">
            💬 Ejemplo real de lo que vas a aprender:
          </h3>

          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-4 md:p-6 mb-6 space-y-4" data-id="element-61">
            {/* Received message */}
            <div className="flex justify-start" data-id="element-62">
              <div className="bg-slate-100 text-slate-800 rounded-2xl rounded-tl-sm py-3 px-4 max-w-[85%] shadow-sm" data-id="element-63">
                <p className="text-sm md:text-base" data-id="element-64">
                  Los chicos se acuestan tardísimo con vos…
                </p>
              </div>
            </div>

            {/* Response message */}
            <div className="flex justify-end" data-id="element-65">
              <div className="bg-green-100 text-green-900 rounded-2xl rounded-tr-sm py-3 px-4 max-w-[85%] shadow-sm" data-id="element-66">
                <p className="text-sm md:text-base" data-id="element-67">
                  Los chicos están bien y tienen su rutina. Lo coordinamos con
                  tiempo.
                </p>
              </div>
            </div>
          </div>

          <p className="text-center font-bold text-slate-200 text-lg" data-id="element-68">
            👉 Sin discutir. Sin escalar. Sin desgaste.
          </p>
        </motion.div>
      </div>
    </section>;
}